import React from 'react'

const About = () => {
    return (
        <div>
            <h1>About Us</h1>
            <p>Our hospital is a reputed hospital in our town.we give to our Patient a 
                great service.Our first priority is our patient.Our has variour kinds of 
                department.There are so many Expart doctor.Our Dorcote is very kindfull.
            </p>
            
        </div>
    )
}

export default About
